// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox","checkbox-label":"checkbox-label"};